import useAddToCartMutation from '../api/useAddToCartMutation';
import builder from '../../../shared/builders/dataLayer';

export default function useAddToCart() {
  const { mutate, ...state } = useAddToCartMutation();
  const { addToCartEvent, addSerenityPackToCartEvent, reset: resetBuilder } = builder();

  const addToCart = (productId, quantity, options) => {
    mutate({ productId, quantity }, options);
  };

  const addToCartTag = (product, quantity, prices, refurbishedProduct = null) => {
    window.dataLayer.push(resetBuilder());
    window.dataLayer.push(addToCartEvent(product, quantity, prices, refurbishedProduct));
  };

  const addSerenityPackToCartTag = (serenityPack) => {
    window.dataLayer.push(resetBuilder());
    window.dataLayer.push(addSerenityPackToCartEvent(serenityPack));
  };

  return {
    isLoading: state.isPending,
    addToCart,
    addToCartTag,
    addSerenityPackToCartTag,
  };
}
